import { render } from "./Blogs.vue?vue&type=template&id=3a8276b2&lang=pug"
import script from "./Blogs.vue?vue&type=script&setup=true&lang=js"
export * from "./Blogs.vue?vue&type=script&setup=true&lang=js"

import "./Blogs.vue?vue&type=style&index=0&id=3a8276b2&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__